// @ts-ignore
import lodash from 'lodash'

export function getObjectDifferenceInArray(
    newVal: Record<string, any>,
    oldVal: Record<string, any>
) {
    return lodash.reduce(
        oldVal,
        function (result, value, key: any) {
            return lodash.isEqual(value, newVal[key]) ? result : result.concat(key)
        },
        []
    )
}
export function getObjectDifferenceInObject(
    newVal: Record<string, any>,
    oldVal: Record<string, any>
) {
    const diff = getObjectDifferenceInArray(newVal, oldVal).reduce((result: any, item) => {
        result[item] = newVal[item]
        return result
    }, {})

    return diff
}
